export default __webpack_public_path__ + "static/media/Portuguese(PT).0f4cb234.svg";